<template>
  <rouwdrukwerk />
</template>

<script>
import Rouwdrukwerk from '../components/KeuzesUitvaart/Rouwdrukwerk.vue'

export default {
  name: 'RouwdrukwerkView',
  components: {
    Rouwdrukwerk
  }
}
</script>
